import React, { useState, useEffect } from "react";
import { Field } from "formik";
import Select from "../components/Select";
import classNames from "classnames";

const FiltersModal = ({
  values,
  setFieldValue,
  filters,
  columns,
  handleOrderByChange,
  orderByColumns,
  changeOrderByItemOrder,
  clearFiltri,
  clearOrderBy,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Set default values when the modal is opened if values are undefined
  useEffect(() => {
    if (isOpen) {
      if (values.ritiro_cliente === undefined) {
        setFieldValue("ritiro_cliente", "Tutti");
      }
      if (values.tipologia_consegna === undefined) {
        setFieldValue("tipologia_consegna", "Tutti");
      }
      if (values.evaso === undefined || !values.evaso) {
        setFieldValue("evaso", "No");
      }
      if (values.numero_ordine === undefined) {
        setFieldValue("numero_ordine", "");
      }
      if (values.oneProduct === undefined) {
        setFieldValue("oneProduct", false);
      }
    }
  }, [isOpen, values, setFieldValue]);

  // Count active filters
  const activeFiltersCount = [
    values.ritiro_cliente !== "Tutti",
    values.tipologia_consegna !== "Tutti",
    values.evaso !== "Tutti",
    values.numero_ordine,
    values.oneProduct,
    ...(values.order_by || []),
  ]
    .filter(Boolean)
    .length;

  return (
    <div className="z-50">
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="min-h-c py-2 px-4 bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200 font-semibold hover:bg-gray-200 dark:hover:bg-gray-600 z-50"
      >
        <span className="mr-2">Filtri Avanzati</span>
        {activeFiltersCount > 0 && (
          <span className="px-2 py-0.5 text-xs bg-blue-100 text-blue-600 rounded-full">
            {activeFiltersCount}
          </span>
        )}
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-50"
            onClick={() => setIsOpen(false)}
          />

          <div className="fixed inset-x-0 top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-full max-w-3xl bg-white dark:bg-neutral-800 rounded-lg shadow-xl z-50 p-6">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-xl font-semibold">Filtri e Ordinamento</h2>
              <button
                onClick={() => setIsOpen(false)}
                className="text-neutral-500 hover:text-neutral-700"
              >
                ✕
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Left column - Filters */}
              <div className="space-y-6">
                <div>
                  <h3 className="text-sm font-medium mb-3">Ritiro Cliente</h3>
                  <div className="flex rounded-md overflow-hidden border">
                    {["Si", "No", "Tutti"].map((option) => (
                      <label key={option} className="flex-1">
                        <input
                          type="radio"
                          name="ritiro_cliente"
                          value={option}
                          checked={values.ritiro_cliente === option}
                          onChange={(e) => {
                            setFieldValue("ritiro_cliente", e.target.value);
                          }}
                          className="hidden"
                        />
                        <span
                          className={`block py-2 text-center cursor-pointer ${
                            values.ritiro_cliente === option
                              ? "bg-blue-600 text-white"
                              : "hover:bg-neutral-50 dark:hover:bg-neutral-700"
                          }`}
                        >
                          {option}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                <div>
                  <h3 className="text-sm font-medium mb-3">Tipo Consegna</h3>
                  <div className="flex rounded-md overflow-hidden border">
                    {["Totale", "Parziale", "Tutti"].map((option) => (
                      <label key={option} className="flex-1">
                        <input
                          type="radio"
                          name="tipologia_consegna"
                          value={option}
                          checked={values.tipologia_consegna === option}
                          onChange={(e) =>
                            setFieldValue("tipologia_consegna", e.target.value)
                          }
                          className="hidden"
                        />
                        <span
                          className={`block py-2 text-center cursor-pointer ${
                            values.tipologia_consegna === option
                              ? "bg-blue-600 text-white"
                              : "hover:bg-neutral-50 dark:hover:bg-neutral-700"
                          }`}
                        >
                          {option}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                <div>
                  <h3 className="text-sm font-medium mb-3">
                    Stato ordine evaso
                  </h3>
                  <div className="flex rounded-md overflow-hidden border">
                    {[
                      { label: "Sì", value: "Si" },
                      { label: "No", value: "No" },
                      { label: "Tutti", value: "Tutti" },
                    ].map((option) => (
                      <label key={option.value} className="flex-1">
                        <input
                          type="radio"
                          name="evaso"
                          value={option.value}
                          checked={values.evaso === option.value}
                          onChange={(e) =>
                            setFieldValue("evaso", e.target.value)
                          }
                          className="hidden"
                        />
                        <span
                          className={`block py-2 text-center cursor-pointer ${
                            values.evaso === option.value
                              ? "bg-blue-600 text-white"
                              : "hover:bg-neutral-50 dark:hover:bg-neutral-700"
                          }`}
                        >
                          {option.label}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                <div>
                  <h3 className="text-sm font-medium mb-3">Numero Ordine</h3>
                  <Field
                    name="numero_ordine"
                    type="text"
                    className="w-full px-3 py-2 border rounded-md dark:bg-neutral-700 dark:border-neutral-600 dark:text-white"
                    placeholder="Inserisci n° ordine"
                    disabled={values.oneProduct}
                  />
                </div>

                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="oneProduct"
                    checked={values.oneProduct}
                    onChange={(e) =>
                      setFieldValue("oneProduct", e.target.checked)
                    }
                    className="w-4 h-4 text-blue-600 border-neutral-300 rounded"
                  />
                  <label htmlFor="oneProduct" className="text-sm">
                    Ordini 1 articolo rimanente
                  </label>
                </div>
              </div>

              {/* Right column - Sorting */}
              <div>
                <div className="mb-4 flex justify-between items-center">
                  <h3 className="text-sm font-medium">Ordinamento</h3>
                  {orderByColumns.length > 0 && (
                    <button
                      type="button"
                      onClick={(e) => clearOrderBy(e, setFieldValue)}
                      className="text-sm text-red-600 hover:text-red-700"
                    >
                      Rimuovi Tutti
                    </button>
                  )}
                </div>

                <div className="space-y-2">
                  {orderByColumns.map((item, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between p-2 bg-neutral-50 dark:bg-neutral-700 rounded-md"
                    >
                      <span>{item.label}</span>
                      <div className="flex gap-2">
                        <span
                          onClick={() => changeOrderByItemOrder(item)}
                          className={classNames(
                            "material-symbols-outlined cursor-pointer text-xl",
                            {
                              "text-neutral-300 dark:text-natural-600":
                                item.mode !== "DESC",
                              "text-blue-500 dark:text-blue-400":
                                item.mode === "DESC",
                            }
                          )}
                        >
                          arrow_upward
                        </span>
                        <span
                          onClick={() => changeOrderByItemOrder(item)}
                          className={classNames(
                            "material-symbols-outlined cursor-pointer text-xl",
                            {
                              "text-neutral-300 dark:text-natural-600":
                                item.mode !== "ASC",
                              "text-blue-500 dark:text-blue-400":
                                item.mode === "ASC",
                            }
                          )}
                        >
                          arrow_downward
                        </span>
                      </div>
                    </div>
                  ))}

                  <Select
                    onChange={handleOrderByChange}
                    value=""
                    options={columns?.map((c) => {
                      const labelMap = {
                        "ragione_sociale": "Ragione Sociale",
                        "data_ordine": "Data Ordine"
                      };
                      return {
                        value: c,
                        label: labelMap[c] || c,
                        field: c, // Assicura che il campo venga passato
                      };
                    })}
                    placeholder="+ ordinamento"
                    classNames={{
                      control: () =>
                        "dark:bg-neutral-700 dark:border-neutral-600",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-4 mt-6 pt-6 border-t dark:border-neutral-600">
              <button
                type="button"
                onClick={(e) => {
                  clearFiltri(e);
                  setIsOpen(false);
                }}
                className="px-4 py-2 text-sm border border-red-600 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-md transition-colors"
              >
                Rimuovi Tutti i filtri
              </button>
              <button
                type="submit"
                onClick={() => setIsOpen(false)}
                className="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                Applica Filtri
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FiltersModal;
